import { z } from 'zod';

export const contactFormSchema = z.object({
  fullName: z
    .string()
    .min(2, 'Fill in the full name field, at least 2 characters long.'),
  email: z.email('The field is required in the appropriate format.'),
  topic: z.string().min(1, 'Please choose a topic.'),
  message: z
    .string()
    .min(10, 'The message is required and must be at least 10 characters long'),
  attachments: z
    .array(
      z.object({
        name: z.string().min(1),
        token: z.string().min(1),
      })
    )
    .max(5, "Maximum 5 atts"),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;
